// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".splash-hero[data-v-42306e87]{padding-top:120px}.splash-hero.has-banner[data-v-42306e87]{padding-top:170px}.custom-fixed[data-v-42306e87]{position:fixed!important}@media screen and (max-width:768px){.splash-hero[data-v-42306e87]{padding-top:160px}.splash-hero.has-banner[data-v-42306e87]{padding-top:240px}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
